'use client';

import viLang from './vi.json.js';

var t = function (key, langCode) {
    if (langCode === 'en')
        return key;
    if (typeof viLang[key] === 'undefined')
        return key;
    return viLang[key];
};

export { t };
//# sourceMappingURL=helper.js.map
